export default __webpack_public_path__ + "static/media/meeting-room.6f14629c.svg";